<template>
  <div class="content">
    <div class="header">
      <span style="float: left;">第{{aid}}名</span>
      <span style="width:80%;">{{true_url}}</span>
      <span class="close" @click="close">×</span>
    </div>
    <ul class="tab">
      <li class="tab-item" @click="showType=item.code" :class="{active:showType===item.code}"
          v-for="(item,index) in tabList" :key="index">{{item.name}}
      </li>
    </ul>

    <div class="body" v-loading="isloading">
      <template v-if="showType === '5118'">
        <p style="margin-bottom: 10px">
          <span>域名首页：</span>
          <span class="red">{{isindexinfo}}</span>
          <span style="margin-left: 15px">标题完全包含搜索词：</span>
          <span class="green">{{istitle}}</span>
        </p>
        <table class="table-5118">
          <thead>
          <tr>
            <th></th>
            <th>百度PC</th>
            <th>百度移动</th>
            <th>360好搜</th>
            <th>神马搜索</th>
            <th>头条搜索</th>
            <th>搜狗PR</th>
            <th>谷歌PR</th>
          </tr>
          </thead>
          <tbody>
          <tr style="cursor: pointer;" @click="jump_seo_url(true_url)">
            <td>权重</td>
            <td class="baidu-pc">{{baiduweight}}</td>
            <td class="baidu-mobile">{{baidumobileweight}}</td>
            <td class="haosou">{{haosouweight}}</td>
            <td class="shenma">{{shenmaweight}}</td>
            <td class="toutiao">{{get_5118_data!=null?get_5118_data.reportlist[4].Weight:'0'}}</td>
            <td class="sougou">{{sogou_pr}}</td>
            <td class="google">{{google_pr}}</td>
          </tr>
          <tr style="cursor: pointer;" @click="jump_seo_url(true_url)">
            <td>受宠排名</td>
            <td>{{Math.abs(baidurank)==2147483647?0:baidurank}}<br>
              <img v-if="baidupcupdown!=0 && Math.abs(baidupcupdown)!=2147483647"
                   :src="baidupcupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidupcupdown!=0 && Math.abs(baidupcupdown)!=2147483647"
                    :style="{color:(baidupcupdown>0?`red`:`green`)}">{{Math.abs(baidupcupdown)}}</span>
            </td>
            <td>{{Math.abs(baidumobilerank)==2147483647?0:baidumobilerank}}<br>
              <img v-if="baidumobilupdown!=0 && Math.abs(baidumobilupdown)!=2147483647"
                   :src="baidumobilupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidumobilupdown!=0  && Math.abs(baidumobilupdown)!=2147483647" :style="{color:(baidumobilupdown>0?`red`:`green`)}">{{Math.abs(baidumobilupdown)}}</span>
            </td>
            <td>{{Math.abs(haosourank)==2147483647?0:haosourank}}<br>
              <img v-if="haosouupdown!=0 && Math.abs(haosouupdown)!=2147483647"
                   :src="haosouupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="haosouupdown!=0 && Math.abs(haosouupdown)!=2147483647"
                    :style="{color:(haosouupdown>0?`red`:`green`)}">{{Math.abs(haosouupdown)}}</span>
            </td>
            <td>{{Math.abs(shenmarank)==2147483647?0:shenmarank}}<br>
              <img v-if="shenmaupdown!=0 && Math.abs(shenmaupdown)!=2147483647"
                   :src="shenmaupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="shenmaupdown!=0 && Math.abs(shenmaupdown)!=2147483647"
                    :style="{color:(shenmaupdown>0?`red`:`green`)}">{{Math.abs(shenmaupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?Math.abs(get_5118_data.reportlist[4].T_FavourRank)==2147483647?0:Math.abs(get_5118_data.reportlist[4].T_FavourRank):'0'}}<br>
              <img v-if="toutiaoupdown!=0 && Math.abs(toutiaoupdown)!=2147483647"
                   :src="toutiaoupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="toutiaoupdown!=0 && Math.abs(toutiaoupdown)!=2147483647"
                    :style="{color:(toutiaoupdown>0?`red`:`green`)}">{{Math.abs(toutiaoupdown)}}</span></td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr style="cursor: pointer;" @click="jump_seo_url(true_url)">
            <td>平均排名</td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[0].T_RankAvg:'0'}}<br>
              <img v-if="baidupcAvgupdown!=0"
                   :src="baidupcAvgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidupcAvgupdown!=0"
                    :style="{color:(baidupcAvgupdown>0?`red`:`green`)}">{{Math.abs(baidupcAvgupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[1].T_RankAvg:'0'}}<br>
              <img v-if="baidumAvgupdown!=0"
                   :src="baidumAvgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidumAvgupdown!=0" :style="{color:(baidumAvgupdown>0?`red`:`green`)}">{{Math.abs(baidumAvgupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[2].T_RankAvg:'0'}}<br>
              <img v-if="haosouAvgupdown!=0"
                   :src="haosouAvgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="haosouAvgupdown!=0"
                    :style="{color:(haosouAvgupdown>0?`red`:`green`)}">{{Math.abs(haosouAvgupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[3].T_RankAvg:'0'}}<br>
              <img v-if="shenmaAvgupdown!=0"
                   :src="shenmaAvgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="shenmaAvgupdown!=0"
                    :style="{color:(shenmaAvgupdown>0?`red`:`green`)}">{{Math.abs(shenmaAvgupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[4].T_RankAvg:'0'}}<br>
              <img v-if="toutiaoAvgupdown!=0"
                   :src="toutiaoAvgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="toutiaoAvgupdown!=0"
                    :style="{color:(toutiaoAvgupdown>0?`red`:`green`)}">{{Math.abs(toutiaoAvgupdown)}}</span></td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr style="cursor: pointer;" @click="jump_seo_url(true_url)">
            <td>整域权重</td>
            <td><p class="weight_btn">{{get_5118_data!=null?get_5118_data.reportlist[0].Weight_Domain:'0'}}</p></td>
            <td><p class="weight_btn">{{get_5118_data!=null?get_5118_data.reportlist[1].Weight_Domain:'0'}}</p></td>
            <td><p class="weight_btn">{{get_5118_data!=null?get_5118_data.reportlist[2].Weight_Domain:'0'}}</p></td>
            <td><p class="weight_btn">{{get_5118_data!=null?get_5118_data.reportlist[3].Weight_Domain:'0'}}</p></td>
            <td><p class="weight_btn">{{get_5118_data!=null?get_5118_data.reportlist[4].Weight_Domain:'0'}}</p></td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr style="cursor: pointer;" @click="jump_seo_url(true_url)">
            <td>整域<br>受宠排名</td>
            <td>{{get_5118_data!=null?Math.abs(get_5118_data.reportlist[0].T_FavourRank_Domain)==2147483647?0:get_5118_data.reportlist[0].T_FavourRank_Domain:'0'}}<br>
              <img v-if="baidupcdomainupdown!=0 && Math.abs(baidupcdomainupdown)!=2147483647"
                   :src="baidupcdomainupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidupcdomainupdown!=0 && Math.abs(baidupcdomainupdown)!=2147483647"
                    :style="{color:(baidupcdomainupdown>0?`red`:`green`)}">{{Math.abs(baidupcdomainupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?Math.abs(get_5118_data.reportlist[1].T_FavourRank_Domain)==2147483647?0:get_5118_data.reportlist[1].T_FavourRank_Domain:'0'}}<br>
              <img v-if="baidumdomainupdown!=0 && Math.abs(baidumdomainupdown)!=2147483647"
                   :src="baidumdomainupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidumdomainupdown!=0 && Math.abs(baidumdomainupdown)!=2147483647" :style="{color:(baidumdomainupdown>0?`red`:`green`)}">{{Math.abs(baidumdomainupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?Math.abs(get_5118_data.reportlist[2].T_FavourRank_Domain)==2147483647?0:get_5118_data.reportlist[2].T_FavourRank_Domain:'0'}}<br>
              <img v-if="haosoudomainupdown!=0 && Math.abs(haosoudomainupdown)!=2147483647"
                   :src="haosoudomainupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="haosoudomainupdown!=0 && Math.abs(haosoudomainupdown)!=2147483647"
                    :style="{color:(haosoudomainupdown>0?`red`:`green`)}">{{Math.abs(haosoudomainupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?Math.abs(get_5118_data.reportlist[3].T_FavourRank_Domain)==2147483647?0:get_5118_data.reportlist[3].T_FavourRank_Domain:'0'}}<br>
              <img v-if="shenmadomainupdown!=0 && Math.abs(shenmadomainupdown)!=2147483647"
                   :src="shenmadomainupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="shenmadomainupdown!=0 && Math.abs(shenmadomainupdown)!=2147483647"
                    :style="{color:(shenmadomainupdown>0?`red`:`green`)}">{{Math.abs(shenmadomainupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?Math.abs(get_5118_data.reportlist[4].T_FavourRank_Domain)==2147483647?0:get_5118_data.reportlist[4].T_FavourRank_Domain:'0'}}<br>
              <img v-if="toutiaodomainupdown!=0 && Math.abs(toutiaodomainupdown)!=2147483647"
                   :src="toutiaodomainupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="toutiaodomainupdown!=0 && Math.abs(toutiaodomainupdown)!=2147483647"
                    :style="{color:(toutiaodomainupdown>0?`red`:`green`)}">{{Math.abs(toutiaodomainupdown)}}</span>
            </td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr style="cursor: pointer;" @click="jump_seo_url(true_url)">
            <td>整域<br>平均排名</td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[0].T_RankAvg_Domain:0}}<br>
              <img v-if="baidupcdomainavgupdown!=0"
                   :src="baidupcdomainavgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidupcdomainavgupdown!=0"
                    :style="{color:(baidupcdomainavgupdown>0?`red`:`green`)}">{{Math.abs(baidupcdomainavgupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[1].T_RankAvg_Domain:0}}<br>
              <img v-if="baidumdomainavgupdown!=0"
                   :src="baidumdomainavgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="baidumdomainavgupdown!=0" :style="{color:(baidumdomainavgupdown>0?`red`:`green`)}">{{Math.abs(baidumdomainavgupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[2].T_RankAvg_Domain:0}}<br>
              <img v-if="haosoudomainavgupdown!=0"
                   :src="haosoudomainavgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="haosoudomainavgupdown!=0"
                    :style="{color:(haosoudomainavgupdown>0?`red`:`green`)}">{{Math.abs(haosoudomainavgupdown)}}</span>
            </td>
            <td>{{get_5118_data!=null?get_5118_data.reportlist[3].T_RankAvg_Domain:0}}<br>
              <img v-if="shenmadomainavgupdown!=0"
                   :src="shenmadomainavgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="shenmadomainavgupdown!=0"
                    :style="{color:(shenmadomainavgupdown>0?`red`:`green`)}">{{Math.abs(shenmadomainavgupdown)}}</span>
            </td>
            <td>
              {{get_5118_data!=null?get_5118_data.reportlist[4].T_RankAvg_Domain:0}}<br>
              <img v-if="toutiaodomainavgupdown!=0"
                   :src="toutiaodomainavgupdown>0?require('../assets/image/down.png'):require('../assets/image/up.png')">
              <span v-if="toutiaodomainavgupdown!=0"
                    :style="{color:(toutiaodomainavgupdown>0?`red`:`green`)}">{{Math.abs(toutiaodomainavgupdown)}}</span>
            </td>
            <td>--</td>
            <td>--</td>
          </tr>
          </tbody>
        </table>
        <div style="padding: 10px 0 ">
          <div style="line-height: 25px">
            <img src="../assets/image/baidu.png" style="position: fixed;margin-top: 4px;"><span
            style="padding-left: 20px;">PC排名趋势</span>
            <button class="btn" @click="downrankwords()" style="float: right">
              <img src="../assets/image/down_w.png" style="padding-right: 5px;">下载排名词
            </button>
          </div>
          <div class="row" style="line-height: 25px;cursor: pointer;" @click="jump_seo_url(true_url)">
            <table>
              <tr>
                <td>
                  <v-chart title="百度PC排名趋势▼" :data='getChartData()' id="biadu-pc" :rankallcount='0' :isbaidu="true"
                           :isShow="false"></v-chart>
                </td>
                <td style="padding-left: 10px;">
                  <div style="width:120px;height: 140px;position: absolute;margin-top: -65px;">
                    <p style="float: left;">前10：<span style="color:#6ecd5f">{{baidupctop10}}</span></p><br>
                    <div style="float: left;">前20：<span style="color:#4676d5">{{baidupctop20}}</span></div>
                    <br>

                    <div style="float: left;">前50：<span style="color:#2b86f4">{{baidupctop50}}</span></div>
                    <br>
                    <div style="float: left;">前100：<span style="color:#f7ad5c">{{baidupctop100}}</span></div>
                  </div>
                </td>
              </tr>
            </table>

          </div>
        </div>
        <div class="dotted-line"></div>
        <div style="padding: 10px 0 ">
          <div style="line-height: 25px">
            <span>首页外链</span>
          </div>
          <div class="row" style="cursor: pointer;">
            <a @click="jump_outlink_url(true_url)" target="_blank">
              <table>
                <tr>
                  <td>
                    <v-chart-2 title="首页外链" :data='getOutLinkChartData()' id="biadu-outlink"
                               :isbaidu="true"></v-chart-2>
                  </td>
                  <td style="color: gray;text-align: center;padding-left: 10px;">
                    <div><p style="font-size: 20px;">{{LatestFoundCount}}</p>
                      <p>最新一次发现数量</p></div>
                    <br>
                    <div><p style="font-size: 20px;">{{lingcount(CompareLastCount)}}</p>
                      <p>较上次</p></div>
                    <br>
                  </td>
                </tr>
              </table>
            </a>
          </div>
          <div class="col-30" style="padding-top: 10px;">{{whois_created}}</div>
          <div class="dotted-line"></div>
        </div>
        <!-- <div style="padding: 5px 0 ">
          <div class="row" style="line-height: 25px">
            <div class="col-15">ALEXA排名：{{alexa_rank}}</div>
            <div class="col-15"><br></div>
            <div class="col-15">预估日均IP≈{{alexa_ip}}</div>
            <div class="col-15">预估日均PV≈{{alexa_pv}}</div>
          </div>
        </div>
        <div class="dotted-line"></div>
        <div style="padding: 5px 0 ">
          <div class="row" style="line-height: 25px">
            <div class="col-15">网站速度：{{speed}}</div>
            <div class="col-23">名称：{{icp_company}}</div>
            <div class="col-7">性质：{{icp_type}}</div>
            <div class="col-30">{{whois_created}}</div>
          </div>
        </div>
        <div class="dotted-line"></div>
        <div style="padding: 5px 0 ">
          <div class="row" style="line-height: 25px">
            <div class="col-15">安全联盟：<img width="80px" :src="safeinfo" style="vertical-align: middle;"></div>
            <div class="col-15">SSL证书：<img width="100px" :src="httpsinfo" style="vertical-align: middle;"></div>
          </div>
        </div> -->
      </template>
      <template v-if="showType === 'other'">
        <p style="margin-bottom: 10px">
          <strong>爱站数据</strong>
        </p>
        <table class="table-aizhan">
          <tbody>
          <tr>
            <td>SEO<br>信息</td>
            <td>
              <div class="row">
                <div class="col-30">百度来路：<span class="red">{{baidurank_ip}}</span>IP</div>
                <div class="col-30">移动来路：<span>{{baidurank_m_ip}}</span>IP</div>
                <div class="col-15">出站链接：<span>{{webpage_link_o}}</span></div>
                <div class="col-15">首页内链：<span>{{webpage_link_i}}</span></div>
              </div>
              <div class="line" style="margin: 5px 0 5px -5px;width: calc(100% + 10px);"></div>
              <div class="row weight ">
                <div class="col-15">百度权重：
                  <div v-html='baidurank_br'></div>
                </div>
                <div class="col-15">移动权重：
                  <div v-html='baidurank_mbr'></div>
                </div>
              </div>
            </td>
          </tr>

          </tbody>
        </table>

        <div style="padding: 5px 0 ">
          <div class="row" style="line-height: 25px">
            <div class="col-15">ALEXA排名：{{alexa_rank}}</div>
            <div class="col-15"><br></div>
            <div class="col-15">预估日均IP≈{{alexa_ip}}</div>
            <div class="col-15">预估日均PV≈{{alexa_pv}}</div>
          </div>
        </div>
        <div class="dotted-line"></div>
        <div style="padding: 5px 0 ">
          <div class="row" style="line-height: 25px">
            <div class="col-15">网站速度：{{speed}}</div>
            <div class="col-23">名称：{{icp_company}}</div>
            <div class="col-7">性质：{{icp_type}}</div>

          </div>
        </div>
        <div class="dotted-line"></div>
        <p style="margin: 10px 0">
          <strong>chinaz数据</strong>
        </p>
        <table v-if="ischinazshow===1" class="table-chinaz">
          <tbody>
          <tr>
            <td>SEO<br>信息</td>
            <td>
              <div class="row weight">
                <div class="col-15">百度权重：<img :src="baidupcimg" style="vertical-align: middle"></div>
                <div class="col-15">移动权重：<img :src="baidumobilepr" style="vertical-align: middle"></div>
                <div class="col-15">360权重：&nbsp;<img :src="haosoupr" style="vertical-align: middle"></div>
                <div class="col-15"></div>
                <div class="col-15">神马权重：<img :src="smpcimg" style="vertical-align: middle"></div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div v-if="ischinazshow===2" style="height:100px"><span style="color:red"><strong>该域名被Chinaz屏蔽查询</strong></span>
        </div>

        <div class="dotted-line"></div>
        <div style="padding: 5px 0 ">
          <div class="row" style="padding-top: 5px;">
            <div class="col-15">安全联盟：<img width="80px" :src="safeinfo" style="vertical-align: middle;"></div>
            <div class="col-15">SSL证书：<img width="100px" :src="httpsinfo" style="vertical-align: middle;"></div>
          </div>
        </div>

      </template>

    </div>
  </div>
</template>

<script>
  class Tab {
    constructor(name, code) {
      this.code = code;
      this.name = name;
    }
  }

  export default {
    data() {
      return {
        showType: "5118",
        tabList: [new Tab("5118", "5118"), new Tab("爱站/chinaz", "other")],
        baidurank: 0,
        baiduweight: 0,
        baidumobilerank: 0,
        baidumobileweight: 0,
        haosourank: 0,
        haosouweight: 0,
        baidupctop10: 0,
        baidupctop20: 0,
        baidupctop50: 0,
        baidupctop100: 0,
        baidupcupdown: 0,
        baidumobilupdown: 0,
        haosouupdown: 0,
        shenmarank: 0,
        shenmaweight: 0,
        shenmaupdown: 0,
        toutiaorank: 0,
        toutiaoweight: 0,
        toutiaoupdown: 0,

        baidupcAvgupdown: 0,
        baidumAvgupdown: 0,
        haosouAvgupdown: 0,
        shenmaAvgupdown: 0,
        toutiaoAvgupdown: 0,

        baidupcdomainupdown: 0,
        baidumdomainupdown: 0,
        haosoudomainupdown: 0,
        shenmadomainupdown: 0,
        toutiaodomainupdown: 0,

        baidupcdomainavgupdown: 0,
        baidumdomainavgupdown: 0,
        haosoudomainavgupdown: 0,
        shenmadomainavgupdown: 0,
        toutiaodomainavgupdown: 0,

        get_5118_data: null,


        alexa_ip: 0,
        alexa_pv: 0,
        alexa_rank: 0,
        backlink: 0,
        baidurank_br: "",
        baidurank_ip: "",
        baidurank_m_ip: "",
        baidurank_mbr: "",
        google_pr: "",
        icp_company: "",
        icp_icp: "",
        icp_passtime: "",
        icp_type: "",
        sogou_pr: "",
        speed: "",
        webpage_link_i: "",
        webpage_link_o: "",
        whois_created: "",
        whois_registrant: "",

        baidumobilepr: "",
        baidupcimg: "",
        smpcimg: "",
        domainage: "",
        googleimg: "",
        haosoupr: "",
        httpsinfo: "",
        icpname: "",
        icpno: "",
        icptime: "",
        icptype: "",
        ipwebnum: "0",
        outlink: "0",
        safeinfo: "",
        ischinazshow: 1,

        aid: '',
        isindexinfo: '',
        istitle: '',
        ranktitle: '',
        true_url: '',
        chart: {},
        outlinkchart: {},
        isloading: false,
        CompareLastCount: 0,
        LatestFoundCount: 0,
        datalist: []
      }
    },
    mounted() {
      this.$messenger.addTarget(window.parent, 'parent');
      this.$messenger.targets['parent'].send("BaiDu_Rank_SeoList_Check");
      this.listen();
    },
    methods: {
      close() {
        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send("Close-Baidu-WebSite-Info");
      },
      downrankwords() {
        window.open('https://www.5118.com/seo/baidurank/' + this.true_url + '?f=plugin')
      },
      jump_seo_url(url) {
        window.open('https://seo.5118.com/' + url + '?f=plugin');
      },
      jump_outlink_url(url) {
        window.open('https://ahrefs.5118.com/' + url);
      },
      getChartData() {

        try {
          let chartData = this.chart;
          let _ = chartData;
          return _;
        } catch (e) {
          return {}
        }

      },
      getOutLinkChartData() {

        if (this.datalist.length > 0) {
          return JSON.parse(this.datalist);
        } else {
          return {"date": [], "result": []}
        }
      },
      lingcount(num) {
        let msg = ''
        msg = num > 0 ? '+' + num : num;
        return msg;
      },
      listen() {

        this.$bdseorankmessageer.listen("_5118_BaiduPC_Rank_List_info", (msg) => {
          this.chart = eval("(" + msg + ")");
          this.isloading = false;
        });

        this.$bdseorankmessageer.listen("_5118_BaiduPC_OutLink_List_info", (msg) => {
          this.outlinkchart = eval("(" + msg + ")");
          this.datalist = this.outlinkchart.ChartJSON;
          this.LatestFoundCount = this.outlinkchart.LatestFoundCount;
          this.CompareLastCount = this.outlinkchart.CompareLastCount;
          this.isloading = false;
        });

        this.$bdseorankmessageer.listen("_5118_Baidu_Seo_Rank_ListFirst_Info", (msg) => {
          this.aid = msg.aid;
          this.isindexinfo = msg.isindexinfo;
          this.istitle = msg.istitle;
          this.ranktitle = msg.ranktitle;
          this.true_url = msg.true_url;
        });

        //爱站数据
        this.$bdseorankmessageer.listen("_5118_Baidu_Seo_Rank_ListAiZhan_Info", (msg) => {
          // console.log(msg);
          this.alexa_ip = msg.alexa_ip;
          this.alexa_pv = msg.alexa_pv;
          this.alexa_rank = msg.alexa_rank;
          this.backlink = msg.backlink;
          this.baidurank_br = msg.baidurank_br;
          this.baidurank_ip = msg.baidurank_ip;
          this.baidurank_m_ip = msg.baidurank_m_ip;
          this.baidurank_mbr = msg.baidurank_mbr;
          this.google_pr = msg.google_pr;
          this.icp_company = msg.icp_company;
          this.icp_icp = msg.icp_icp;
          this.icp_passtime = msg.icp_passtime;
          this.icp_type = msg.icp_type;
          this.sogou_pr = msg.sogou_pr;
          this.speed = msg.speed;
          this.webpage_link_i = msg.webpage_link_i;
          this.webpage_link_o = msg.webpage_link_o;
          this.whois_created = msg.whois_created;
          this.whois_registrant = msg.whois_registrant;
          this.isloading = false;
        });

        //chinaz数据
        this.$bdseorankmessageer.listen("_5118_Baidu_Seo_Rank_ListChinaz_Info", (msg) => {
          if (msg != "nodata") {
            this.baidumobilepr = msg.baidumobilepr;
            this.baidupcimg = msg.baidupcimg;
            this.smpcimg = msg.smpcpr;
            this.domainage = msg.domainage;
            this.googleimg = msg.googleimg;
            this.haosoupr = msg.haosoupr;
            this.httpsinfo = msg.httpsinfo;
            this.icpname = msg.icpname;
            this.icpno = msg.icpno;
            this.icptime = msg.icptime;
            this.icptype = msg.icptype;
            this.ipwebnum = msg.ipwebnum;
            this.outlink = msg.outlink;
            this.safeinfo = msg.safeinfo;
            this.ischinazshow = 1;
          } else {
            this.ischinazshow = 2;
          }
          this.isloading = false;
        });

        //5118数据
        this.$bdseorankmessageer.listen("_5118_Baidu_Seo_Rank_ListMain_Info", (msg) => {
          this.baidupctop10 = msg.toplist.Top10;
          this.baidupctop20 = msg.toplist.Top20;
          this.baidupctop50 = msg.toplist.Top50;
          this.baidupctop100 = msg.toplist.Top100;
          this.baidurank = msg.reportlist[0].T_FavourRank;
          this.baiduweight = msg.reportlist[0].Weight;
          this.baidumobilerank = msg.reportlist[1].T_FavourRank;
          this.baidumobileweight = msg.reportlist[1].Weight;
          this.haosourank = msg.reportlist[2].T_FavourRank;
          this.haosouweight = msg.reportlist[2].Weight;
          this.baidupcupdown = msg.reportlist[0].T_FavourRank - msg.reportlist[0].Y_FavourRank;
          this.baidumobilupdown = msg.reportlist[1].T_FavourRank - msg.reportlist[1].Y_FavourRank;
          this.haosouupdown = msg.reportlist[2].T_FavourRank - msg.reportlist[2].Y_FavourRank;
          this.shenmarank = msg.reportlist[3].T_FavourRank;
          this.shenmaweight = msg.reportlist[3].Weight;
          this.shenmaupdown = msg.reportlist[3].T_FavourRank - msg.reportlist[3].Y_FavourRank;
          this.toutiaoupdown = msg.reportlist[4].T_FavourRank - msg.reportlist[4].Y_FavourRank;

          this.baidupcAvgupdown = msg.reportlist[0].T_RankAvg - msg.reportlist[0].Y_RankAvg;
          this.baidumAvgupdown = msg.reportlist[1].T_RankAvg - msg.reportlist[1].Y_RankAvg;
          this.haosouAvgupdown = msg.reportlist[2].T_RankAvg - msg.reportlist[2].Y_RankAvg;
          this.shenmaAvgupdown = msg.reportlist[3].T_RankAvg - msg.reportlist[3].Y_RankAvg;
          this.toutiaoAvgupdown = msg.reportlist[4].T_RankAvg - msg.reportlist[4].Y_RankAvg;

          this.baidupcdomainupdown = msg.reportlist[0].T_FavourRank_Domain - msg.reportlist[0].Y_FavourRank_Domain;
          this.baidumdomainupdown = msg.reportlist[1].T_FavourRank_Domain - msg.reportlist[1].Y_FavourRank_Domain;
          this.haosoudomainupdown = msg.reportlist[2].T_FavourRank_Domain - msg.reportlist[2].Y_FavourRank_Domain;
          this.shenmadomainupdown = msg.reportlist[3].T_FavourRank_Domain - msg.reportlist[3].Y_FavourRank_Domain;
          this.toutiaodomainupdown = msg.reportlist[4].T_FavourRank_Domain - msg.reportlist[4].Y_FavourRank_Domain;

          this.baidupcdomainavgupdown = msg.reportlist[0].T_RankAvg_Domain - msg.reportlist[0].Y_RankAvg_Domain;
          this.baidumdomainavgupdown = msg.reportlist[1].T_RankAvg_Domain - msg.reportlist[1].Y_RankAvg_Domain;
          this.haosoudomainavgupdown = msg.reportlist[2].T_RankAvg_Domain - msg.reportlist[2].Y_RankAvg_Domain;
          this.shenmadomainavgupdown = msg.reportlist[3].T_RankAvg_Domain - msg.reportlist[3].Y_RankAvg_Domain;
          this.toutiaodomainavgupdown = msg.reportlist[4].T_RankAvg_Domain - msg.reportlist[4].Y_RankAvg_Domain;

          this.get_5118_data = msg;
          this.isloading = false;

        });
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .content {
    border: 2px solid @theme-color;
    background-color: white;
    font-size: 12px;
    width: 477px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .2);

    .header {
      line-height: 24px;
      background-color: @theme-color;
      color: white;
      padding: 0 15px;
      font-size: 14px;
      text-align: center;

      .close {
        cursor: pointer;
        font-size: 25px;
        width: 3%;
        height: 20px;
        line-height: 16px;
        text-align: center;
        float: right;
      }
    }

    .tab {
      display: table;
      width: 100%;
      background-color: #ebf2fe;
      line-height: 32px;
      margin: 0;

      .tab-item {
        list-style: none;
        float: left;
        width: 50%;
        text-align: center;
        cursor: pointer;
        color: #666;
        margin: 0;
        line-height: 32px;

        &.active {
          background-color: white;
          color: @theme-color
        }
      }
    }

    .body {
      .new_tr_height(@s,@n:2) when (@n<@s) {
        &:nth-child(@{n}) {
          height: 40px;
        }
        .new_tr_height(@s, (@n+1))
      }
      padding: 15px;

      .table-5118 {
        width: 100%;
        border-collapse: collapse;
        text-align: center;
        border: 1px solid #ccc;
        border-image: initial;
        table-layout: fixed;

        th {
          font-size: 12px;
          line-height: 30px;
          text-align: center;
          vertical-align: middle;
          padding: 0;
          border: 1px solid #ccc;
          border-image: initial;
          background-color: #edf2f6;
        }

        tr {
          .new_tr_height(5)
        }

        td {
          font-size: 12px;
          text-align: center;
          vertical-align: middle;
          padding: 5px 3px;
          border: 1px solid #ccc;
          border-image: initial;
          color: #666;
          .weight_btn{
            padding: 5px 10px;
            background: #f6f6f6;
            border-radius: 15px;
            color: @theme-color;
          }

          &.baidu-pc {
            padding-left: 24px;
            color: white;
            background: url('../assets/image/baidupc.png') no-repeat center;
          }

          &.baidu-mobile {
            padding-left: 24px;
            color: white;
            background: url('../assets/image/baidumobile.png') no-repeat center;
          }

          &.haosou {
            padding-left: 24px;
            color: white;
            background: url('../assets/image/360.png') no-repeat center;
          }

          &.sougou {
            padding-left: 24px;
            color: white;
            background: url('../assets/image/sougou.png') no-repeat center;
          }

          &.google {
            padding-left: 24px;
            color: white;
            background: url('../assets/image/google.png') no-repeat center;
          }

          &.shenma {
            padding-left: 24px;
            color: white;
            background: url('../assets/image/shenma.png') no-repeat center;
          }

          &.toutiao {
            padding-left: 24px;
            color: white;
            background: url('../assets/image/toutiao.png') no-repeat center;
          }
        }
      }

      .table-aizhan {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #ccc;
        border-image: initial;
        table-layout: fixed;

        td {
          font-size: 12px;
          vertical-align: middle;
          padding: 5px;
          border: 1px solid #ccc;
          border-image: initial;
          color: #666;

          &:first-child {
            text-align: center;
            background-color: #edf2f6;
            width: 60px;
          }

          .row {
            line-height: 25px;

            &.weight {
              .bg {
                height: 25px;
                width: 70px;
                font-size: 15px;
                color: rgb(255, 255, 255);
                text-align: center;
                margin: 0 auto;
                display: inline-block;
                vertical-align: bottom;
              }

              .baidu-pc {
                .bg();
                background: url('../assets/image/baidupc.png') no-repeat center;
              }
            }
          }
        }
      }

      .table-chinaz {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #ccc;
        border-image: initial;
        table-layout: fixed;

        td {
          font-size: 12px;
          vertical-align: middle;
          padding: 5px;
          border: 1px solid #ccc;
          border-image: initial;
          color: #666;

          &:first-child {
            text-align: center;
            width: 60px;
          }

          .row {
            line-height: 25px;

            &.weight {
              .bg {
                height: 25px;
                width: 70px;
                font-size: 15px;
                color: rgb(255, 255, 255);
                text-align: center;
                margin: 0 auto;
                display: inline-block;
                vertical-align: bottom;
              }

              .baidu-pc {
                .bg();
                background: url('../assets/image/baidupc.png') no-repeat center;
              }
            }
          }
        }
      }
    }

    .red {
      color: red;
    }

    .blue {
      color: @theme-color;
    }

    .green {
      color: @green;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/BaiduWebsite.vue